// src/features/landing/presentation/components/RbBridgeServiceSection.jsx
// 서비스(/service) — GA 전문 인력 서비스 다음에 붙는 두 번째 서비스, RB Bridge(보험 지사 M&A 중개). 상세는 /rb-bridge.
import React from "react";
import { Link } from "react-router-dom";

const STEPS = [
    { title: "익명 등록", body: "실명·소속 없이 조직 정보를 등록하면, 운영팀이 조직을 특정할 수 없는 요약 카드로 정리합니다." },
    { title: "인수자 인증", body: "자본력과 인수 목적을 사전에 확인한 인수자만 요약 정보를 열람합니다." },
    { title: "프라이빗 매칭", body: "실적·수수료 흐름 같은 핵심 정보는 NDA 체결 후 필요한 만큼 단계적으로 공개합니다." },
    { title: "대면 클로징", body: "프라이빗 미팅룸에서 최종 협상을 진행하고, 제휴 법무·세무·노무 전문가와 함께 계약까지 지원합니다." },
];

export function RbBridgeServiceSection() {
    const search = typeof window !== "undefined" ? window.location.search : "";
    return (
        <section className="rbs-section">
            <div className="rbs-container">
                <div className="rbs-head">
                    <p className="rbs-kicker">SERVICE · M&amp;A</p>
                    <h2 className="rbs-title">
                        보험 지사 거래도,
                        <br />
                        <span className="rbs-accent">RB Bridge</span>가 비공개로 중개합니다.
                    </h2>
                    <p className="rbs-desc">
                        3억~20억 원 규모 소형 보험 지사 거래를 위한 라이징브로커즈 M&amp;A 사업부입니다.
                        정보가 알려지는 순간 조직이 흔들린다는 것을 알기에, 모든 단계는 양측이 동의할 때만 다음으로 넘어갑니다.
                    </p>
                </div>

                <ol className="rbs-steps">
                    {STEPS.map((s, i) => (
                        <li key={s.title} className="rbs-step">
                            <span className="rbs-step-no">STEP {i + 1}</span>
                            <h3 className="rbs-step-title">{s.title}</h3>
                            <p className="rbs-step-body">{s.body}</p>
                        </li>
                    ))}
                </ol>

                <div className="rbs-actions">
                    <Link to="/rb-bridge" className="rbs-btn rbs-btn--primary">RB 브릿지 알아보기</Link>
                    {/* 2026-10-03: 카카오톡 채널 → /rb-bridge 상담 박스(#consult). utm_* 쿼리는 유지 */}
                    <Link to={`/rb-bridge${search}#consult`} className="rbs-btn rbs-btn--ghost">
                        비공개 상담 신청
                    </Link>
                </div>
                <p className="rbs-note">등록과 상담은 무료이며, 상담만으로 등록되지 않습니다.</p>
            </div>

            <style jsx>{`
                .rbs-section {
                    background: linear-gradient(180deg, #1e3a5f 0%, #172d4a 100%);
                    padding: 120px 20px;
                    color: #fff;
                    word-break: keep-all;
                }
                .rbs-container {
                    max-width: 1120px;
                    margin: 0 auto;
                }
                .rbs-head {
                    text-align: center;
                    margin-bottom: 64px;
                }
                .rbs-kicker {
                    margin: 0 0 16px;
                    font-size: 13px;
                    font-weight: 700;
                    letter-spacing: 0.1em;
                    color: #f0a36b;
                }
                .rbs-title {
                    margin: 0;
                    font-size: 2.4rem;
                    line-height: 1.35;
                    font-weight: 800;
                    color: #fff;
                }
                .rbs-accent {
                    color: #ff7a2b;
                }
                .rbs-desc {
                    max-width: 720px;
                    margin: 24px auto 0;
                    font-size: 1.02rem;
                    line-height: 1.85;
                    color: rgba(255, 255, 255, 0.75);
                }
                .rbs-steps {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    display: grid;
                    grid-template-columns: repeat(4, minmax(0, 1fr));
                    gap: 16px;
                    counter-reset: none;
                }
                .rbs-step {
                    padding: 28px 24px 32px;
                    border-radius: 12px;
                    background: rgba(255, 255, 255, 0.06);
                    border: 1px solid rgba(255, 255, 255, 0.12);
                    text-align: left;
                }
                .rbs-step-no {
                    display: inline-block;
                    margin-bottom: 14px;
                    font-size: 12px;
                    font-weight: 800;
                    letter-spacing: 0.06em;
                    color: #ff7a2b;
                }
                .rbs-step-title {
                    margin: 0 0 12px;
                    font-size: 1.2rem;
                    font-weight: 800;
                    color: #fff;
                }
                .rbs-step-body {
                    margin: 0;
                    font-size: 0.92rem;
                    line-height: 1.75;
                    color: rgba(255, 255, 255, 0.72);
                }
                .rbs-actions {
                    display: flex;
                    justify-content: center;
                    gap: 12px;
                    margin-top: 56px;
                }
                .rbs-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    padding: 14px 28px;
                    border-radius: 999px;
                    font-size: 15px;
                    font-weight: 700;
                    text-decoration: none;
                    white-space: nowrap;
                    transition: background 0.2s ease, border-color 0.2s ease;
                }
                .rbs-btn--primary {
                    background: #f16102;
                    color: #fff;
                    border: 1px solid #f16102;
                }
                .rbs-btn--primary:hover {
                    background: #d95502;
                    border-color: #d95502;
                }
                .rbs-btn--ghost {
                    background: transparent;
                    color: #fff;
                    border: 1px solid rgba(255, 255, 255, 0.4);
                }
                .rbs-btn--ghost:hover {
                    border-color: #fff;
                }
                .rbs-note {
                    margin: 18px 0 0;
                    text-align: center;
                    font-size: 13px;
                    color: rgba(255, 255, 255, 0.55);
                }

                @media (max-width: 1024px) {
                    .rbs-steps {
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                    }
                }
                @media (max-width: 768px) {
                    .rbs-section {
                        padding: 72px 20px;
                    }
                    .rbs-head {
                        margin-bottom: 40px;
                    }
                    .rbs-title {
                        font-size: 1.6rem;
                    }
                    .rbs-desc {
                        font-size: 0.95rem;
                    }
                    .rbs-steps {
                        grid-template-columns: minmax(0, 1fr);
                        gap: 12px;
                    }
                    .rbs-step {
                        padding: 22px 20px;
                    }
                    .rbs-actions {
                        flex-direction: column;
                        margin-top: 40px;
                    }
                }
            `}</style>
        </section>
    );
}
